// import axios from "axios"
// import { MessageBox, loading, Loading } from "element-ui"
// import router from "../router/index.js"
// import apiToken from '../common/token.js'
// import { getCurrentUserInfo } from '../common/otherService';

// const requests = axios.create({
//     baseURL: "/api",
//     timeout: 300000

// })

// let loadingInstance = null


// //请求拦截器
// requests.interceptors.request.use(config => {
//     if (router.currentRoute.path != '/login') {
//         const tokenFuction = getCurrentUserInfo() ? getCurrentUserInfo() : 'undefined';
//         if (tokenFuction) {
//             var token = tokenFuction.token || tokenFuction;
//         } else {
//             var token = 'undefined';
//         }

//         if (token && token != "undefined") {

//             const url = config.url
//             const urlarr = url.split('/')

//             const requestToken = apiToken(urlarr[1])
//             config.headers.token = requestToken
//         } else {
//             MessageBox.alert("Token无效，请重新登录", {
//                 title: "Token失效",
//                 confirmButtonText: "返回登录",
//                 callback: action => {
//                     window.location.href = "/login"
//                 }
//             })

//             return Promise.reject()
//         }
//     }
//     if (!config.headers.noLoad) {
//         loadingInstance = Loading.service({
//             text: "加载中", // 设置 loading 文本为 "加载中"
//             spinner: "el-icon-loading", // 使用 Element UI 提供的加载图标
//             background: "rgba(0, 0, 0, 0.7)", // 设置 loading 遮罩层背景色为半透明黑色
//             target: document.querySelector("body"), // 将 loading 遮罩层挂载到页面 body 元素上
//         });
//     }

//     return config
// }, err => {
//     if (loadingInstance) {
//         loadingInstance.close();
//     }

//     return Promise.reject(err)
// })

// requests.interceptors.response.use(res => {
//     console.log(res.data)
//     if (loadingInstance) {
//         loadingInstance.close();
//     }
//     if (res.data.code == 40004) {

//         MessageBox.alert(res.data.message, {
//             title: "非法访问",
//             confirmButtonText: "返回登录",
//             callback: action => {
//                 window.location.href = "/login"
//             }
//         })
//         return false
//     } else {
//         return JSON.parse(res.data)

//     }

// }, err => {
//     if (loadingInstance) {
//         loadingInstance.close();
//     }

//     return Promise.reject(err)
// })

// export default requests

import axios from "axios";
import { MessageBox, Loading } from "element-ui";
import router from "../router/index.js";
import apiToken from '../common/token.js';
import { getCurrentUserInfo } from '../common/otherService';

// 创建 axios 实例
const requests = axios.create({
    baseURL: "/api",
    timeout: 300000, // 5分钟超时
});

// Loading 计数器，防止重复开启
let loadingCount = 0;
let loadingInstance = null;

// 不需要认证的路径白名单
const noAuthPaths = ['/login', '/register', '/public', '/forget'];

// 显示 loading
function showLoading() {
    if (loadingCount === 0) {
        loadingInstance = Loading.service({
            text: "加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            target: document.querySelector("body"),
        });
    }
    loadingCount++;
}

// 隐藏 loading
function hideLoading() {
    loadingCount--;
    if (loadingCount <= 0) {
        loadingCount = 0;
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
    }
}

// 请求拦截器
requests.interceptors.request.use(
    config => {
        const currentPath = router.currentRoute.path;

        // 白名单路径跳过 token 检查
        if (!noAuthPaths.includes(currentPath)) {
            const userInfo = getCurrentUserInfo();

            // 检查用户信息和 token
            if (!userInfo) {
                // MessageBox.alert("用户信息不存在，请重新登录", "未登录", {
                //     confirmButtonText: "返回登录",
                //     callback: () => {
                //         window.location.href = "/login";
                //     }
                // });
                return new Promise(() => {});
            }

            const token = userInfo.token;
            if (!token || token === 'undefined') {
                MessageBox.alert("Token缺失或无效，请重新登录", "登录失效", {
                    confirmButtonText: "返回登录",
                    callback: () => {
                        window.location.href = "/login";
                    }
                });
                return new Promise(() => {});
            }

            // 使用 apiToken 生成接口级 token（如果你的设计如此）
            try {
                const urlArr = config.url.split('/').filter(Boolean); // 过滤空字符串
                const module = urlArr[0]; // 取第一个路径段作为模块标识
                const requestToken = apiToken(module);
                config.headers.token = requestToken || token; // fallback 到主 token
            } catch (e) {
                console.warn("apiToken 生成失败，使用默认 token", e);
                config.headers.token = token;
            }
        }

        // 控制是否显示 loading
        if (!config.headers.noLoad) {
            showLoading();
        }

        return config;
    },
    error => {
        // 请求错误处理（如网络断开等）
        if (error.config && (!error.config.headers || !error.config.noLoad)) {
            hideLoading();
        }
        return Promise.reject(error);
    }
);

// 响应拦截器
requests.interceptors.response.use(
    response => {
        const config = response.config;

        // 关闭 loading
        if (!config.headers.noLoad) {
            hideLoading();
        }

        const resData = JSON.parse(response.data);
        // console.log(resData.data);
        // 假设后端返回 { code: 40004, message: "非法访问" } 表示 token 失效
        if (resData.code === 40004) {
            MessageBox.alert(resData.message || "登录状态已失效，请重新登录", "非法访问", {
                confirmButtonText: "返回登录",
                callback: () => {
                    window.location.href = "/login";
                }
            });
            return Promise.reject(new Error('40004'));
        }

        // 其他业务错误码可根据需要处理
        // if (resData.code !== 0 && resData.code !== 200) {
        //     MessageBox.alert(resData.message || '请求失败', '错误');
        //     return Promise.reject(resData);
        // }

        // ✅ 正确返回数据（axios 已自动 JSON.parse）
        return resData;
    },
    error => {
        // 关闭 loading
        if (error.config && !error.config.headers.noLoad) {
            hideLoading();
        }

        // 统一错误提示
        if (error.response) {
            const { status, data } = error.response;

            if (status === 401) {
                MessageBox.alert("登录已过期或无权限访问", "请重新登录", {
                    confirmButtonText: "去登录",
                    callback: () => {
                        window.location.href = "/login";
                    }
                });
            } else if (status === 404) {
                MessageBox.alert("请求的资源不存在", "404 错误");
            } else if (status >= 500) {
                MessageBox.alert("操作失败，请稍后重试", "操作失败");
            } else {
                MessageBox.alert(data.message || `请求失败：${status}`, "请求异常");
            }
        } else if (error.request) {
            MessageBox.alert("网络连接失败，请检查您的网络", "网络错误");
        } else {
            MessageBox.alert("请求异常：" + error.message, "异常");
        }

        return Promise.reject(error);
    }
);

export default requests;